import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  block: {
    display: "block",
    backgroundColor: "var(--background)",
    boxShadow: "0 2px 2px rgba(0, 0, 0, 0.06)",
    padding: "1.5em",
    margin: "0.5em 0",
  },
  helpBlock: {
    backgroundColor: "var(--background)",
    boxShadow: "none",
    color: "var(--muted-foreground)",
    border: "1px solid var(--border)",
  },
});
